import { useI18n } from '@/hooks/useI18n';
import { formatPlanAmount } from '@/lib/builder/utils/payment-format';

interface PlatformFeeDueBannerProps {
    /** null quando le commissioni non riguardano chi guarda (il viaggiatore). */
    amount: number | null;
    /**
     * Su quanti incassi si e' accumulato. Omesso dove non lo si sa — le schede cliente e
     * consulente aggregano importi, non righe di `payments` — e in quel caso la seconda
     * riga non si disegna invece di stampare "0 incassi", che sarebbe falso.
     */
    count?: number | null;
}

/**
 * Commissioni Place2Be ancora da versare, nelle schede cliente, consulente e viaggio.
 *
 * Nella pagina Pagamenti non c'e' piu': li' lo stesso numero sta nella riga dei contatori,
 * con il tooltip e il tasto. Qui resta un'informazione di contorno sul perimetro della
 * scheda, e un'azione dentro una scheda agirebbe su un perimetro diverso da quello che si
 * sta guardando.
 *
 * È il contraltare dell'aver riaperto "segna come pagata" a TD e agenzia: un incasso
 * dichiarato fuori Stripe non trattiene la fee, e senza un posto in cui quel debito si
 * accumula visibilmente resterebbe una riga in `payments` che nessuno guarda.
 *
 * Sta qui e non come quinta tile fra i KPI di proposito: quella riga dice a che punto e'
 * la cassa, questo non e' un numero da monitorare — è una cosa da fare, e le cose da fare
 * stanno sopra le tabelle. In blu e non in rosso: il rosso di questa pagina e' lo scaduto,
 * cioe' un incasso che non e' arrivato, mentre questa e' una partita fra l'agenzia e noi
 * che si regola in fattura. Vederla dello stesso colore di una rata in ritardo faceva
 * cercare un problema col cliente che non c'e'.
 *
 * Non si disegna nulla se non c'è debito, e nemmeno se `amount` è null: il viaggiatore non
 * deve vedere che esiste una commissione fra l'agenzia e noi.
 */
export const PlatformFeeDueBanner = ({ amount, count }: PlatformFeeDueBannerProps) => {
    const { t } = useI18n();

    if (amount == null || amount <= 0) return null;

    return (
        <div className="flex items-center justify-between gap-4 rounded-lg bg-blue-50 px-4 py-3">
            <div className="flex flex-col leading-tight min-w-0">
                <span className="text-sm font-semibold text-blue-800">
                    {t('payments.platformFee.bannerTitle', {
                        amount: formatPlanAmount(amount),
                    })}
                </span>
                {count != null && (
                    <span className="text-sm text-blue-700 mt-0.5">
                        {t('payments.platformFee.bannerBody', { count })}
                    </span>
                )}
            </div>

        </div>
    );
};
